import { AxiosRequestConfig, AxiosResponse } from 'axios'

import apiClient from '@core/api/client'

export const contentCategoryService = {
	getContentCategories(config?: AxiosRequestConfig): Promise<AxiosResponse> {
		return apiClient.get('/content_categories', config)
	},
}

export default contentCategoryService
